// This needs to be in a different file from the hook,
// to avoid cyclic imports between this and the Auth hooks/components.
export const sessionAccountNumberKey = 'accountNumber';
